/**
 * L'origine publique du studio, pour tout ce qui doit être absolu : canoniques,
 * images OpenGraph, sitemap.
 *
 * Surchargeable par `NEXT_PUBLIC_SITE_URL` afin qu'une préproduction n'annonce
 * pas les URL de production — un sitemap qui pointe ailleurs que là où il est
 * servi est ignoré, et une canonique qui se trompe de domaine désindexe.
 */
export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://studio.virtuosa.io";

/**
 * Le gabarit de titre de document, posé une fois sur le layout racine.
 *
 * Exporté parce que Next applique un gabarit **au rendu** et jamais après :
 * une page qui doit corriger son titre côté client compose le sien à la main,
 * et deux gabarits écrits à deux endroits divergent au premier changement.
 */
export const TITLE_TEMPLATE = "%s · Virtuosa";

/** Le titre complet d'un onglet, gabarit appliqué. */
export function documentTitle(pageTitle: string): string {
  return TITLE_TEMPLATE.replace("%s", pageTitle);
}
